import Svg, { Circle, G, Path } from 'react-native-svg'

export const PlayIcon = ({ height = 48, width = 48, color = 'white' }: { height?: any; width?: any; color?: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 48 48">
      <G id="play" transform="translate(-269 -108)">
        <G id="Group_1861" data-name="Group 1861">
          <G id="Group_1860" data-name="Group 1860">
            <G
              id="Ellipse_61"
              data-name="Ellipse 61"
              transform="translate(269 108)"
              fill="rgba(0,0,0,0.48)"
              stroke={color}
              strokeWidth="1">
              <Circle cx="24" cy="24" r="24" stroke="none" />
              <Circle cx="24" cy="24" r="23.5" fill="none" />
            </G>
            <Path
              id="Polygon_1"
              data-name="Polygon 1"
              d="M8.128,1.549a1,1,0,0,1,1.743,0l7.29,12.96A1,1,0,0,1,16.29,16H1.71a1,1,0,0,1-.872-1.49Z"
              transform="translate(303 123) rotate(90)"
              fill={color}
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
